/**
 * 环境变量配置
 */

// 应用基础配置
export const APP_CONFIG = {
  // 应用标题
  title: import.meta.env.VITE_APP_TITLE || 'Light X for Business',
  // 应用版本
  version: import.meta.env.VITE_APP_VERSION || '1.0.0',
  // 当前环境
  env: import.meta.env.VITE_APP_ENV || 'development',
  // 是否为开发环境
  isDev: import.meta.env.DEV,
  // 是否为生产环境
  isProd: import.meta.env.PROD,
} as const;

// API 配置
export const API_CONFIG = {
  // API 基础地址
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  // SSE 连接路径
  ssePath: import.meta.env.VITE_SSE_PATH || '/resource/sse',
  // 请求超时时间
  timeout: 30000,
} as const;

// 功能开关配置
export const FEATURE_CONFIG = {
  // 是否启用 mock 数据
  enableMock: import.meta.env.VITE_ENABLE_MOCK === 'true',
  // 是否启用调试模式
  enableDebug: import.meta.env.VITE_ENABLE_DEBUG === 'true',
} as const;

/**
 * 获取环境变量值
 * @param key 环境变量键名
 * @param defaultValue 默认值
 * @returns 环境变量值
 */
export const getEnvValue = (key: string, defaultValue?: string): string => {
  return import.meta.env[key] || defaultValue || '';
};

/**
 * 检查是否为开发环境
 */
export const isDevelopment = (): boolean => {
  return APP_CONFIG.env === 'development' || APP_CONFIG.isDev;
};

/**
 * 检查是否为生产环境
 */
export const isProduction = (): boolean => {
  return APP_CONFIG.env === 'production' || APP_CONFIG.isProd;
};

/**
 * 打印环境信息（仅在开发环境）
 */
export const printEnvInfo = (): void => {
  if (isDevelopment()) {
    console.log('🚀 应用环境信息:');
    console.log('📱 应用标题:', APP_CONFIG.title);
    console.log('📦 应用版本:', APP_CONFIG.version);
    console.log('🌍 当前环境:', APP_CONFIG.env);
    console.log('🔗 API 地址:', API_CONFIG.baseURL);
    console.log('⚙️ 功能开关:', FEATURE_CONFIG);
  }
};
